import React from "react";
import { Actions } from "../../core/modules/Actions";
import { ModuleEvents } from "./Actions";
import { onToast } from "../../core/Constant";

const refreshDocumentList = (dispatch) => {
  const course = localStorage.getItem("courseId");
  const parentId = localStorage.getItem("documentParentId");
  const search = localStorage.getItem("documentSearch") || "";
  const params = { course_id: parseInt(course, 10) };

  if (parentId) {
    params.parent_id = parseInt(parentId, 10);
  }
  if (search.trim()) {
    params.search = search.trim();
  }

  dispatch(Actions.document.getDocumentList(params));
};

export default {
  [ModuleEvents.GET_DOCUMENTLIST]: ({ dispatch, payload, appState }) => {
  },
  [ModuleEvents.ADD_DOCUMENT]: ({ dispatch, payload, appState }) => {
    if (
      payload &&
      !payload.error &&
      payload.status &&
      payload.status_code == 1
    ) {
      refreshDocumentList(dispatch);
    }
    onToast("Add Document", payload, false);
  },

  [ModuleEvents.UPDATE_DOCUMENT]: ({ dispatch, payload, appState }) => {
    if (
      payload &&
      !payload.error &&
      payload.status &&
      payload.status_code == 1
    ) {
      refreshDocumentList(dispatch);
    }
    onToast("Update Document", payload, false);
  },

  [ModuleEvents.DELETE_DOCUMENT]: ({ dispatch, payload, appState }) => {
    if (
      payload &&
      !payload.error &&
      payload.status &&
      payload.status_code == 1
    ) {
      refreshDocumentList(dispatch);
    }

  const deleteType = localStorage.getItem("deleteDocumentType");

  onToast(
    deleteType === "folder" ? "Delete Folder" : "Delete Document",
    payload,
    false
  );

  localStorage.removeItem("deleteDocumentType");
  },
  [ModuleEvents.DOCUMENT_STATUS_UPDATE]: ({ dispatch, payload, appState }) => {
    if (
      payload &&
      !payload.error &&
      payload.status &&
      payload.status_code == 1
    ) {
      refreshDocumentList(dispatch);
    }
    const statusType = localStorage.getItem("documentStatusType");

  onToast(
    statusType === "folder"
      ? "Update Folder Status"
      : "Update Document",
    payload,
    false
  );

  localStorage.removeItem("documentStatusType");
  },
  [ModuleEvents.CREATE_FOLDER]: ({ dispatch, payload }) => {
    if (
      payload &&
      !payload.error &&
      payload.status &&
      payload.status_code == 1
    ) {
      refreshDocumentList(dispatch);
    }
    onToast("Create Folder", payload, false);
  },

  [ModuleEvents.SAVE_PAGE_NOTE]: ({ dispatch, payload, appState }) => {
    if (
      payload &&
      !payload.error &&
      payload.status &&
      payload.status_code == 1
    ) {
      refreshDocumentList(dispatch);
    }
    onToast("Notes Action", payload, false);
  },

  [ModuleEvents.GET_PAGE_NOTE]: ({ dispatch, payload, appState }) => {
    if (
      payload &&
      !payload.error &&
      payload.status &&
      payload.status_code == 1
    ) {
      // Refresh list or trigger additional state updates if needed
      refreshDocumentList(dispatch);
    }
  },
};